<div class="container-fluid">
  <!-- Close button (cross) in the top-right corner -->
  <button class="close-btn" (click)="onClose()">
    <i class="feather icon-x"></i> <!-- Cross icon -->
  </button>
    <div class="row justify-content-center ">

        <div>
            <div>
                <div class="card-body">
                    <div class="mb-4 d-md-flex align-items-center justify-content-center">
                        <div>
                            <h4>Issue Material Form</h4>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">

                            <form [formGroup]="addMaterialForm" (ngSubmit)="addMaterial()">
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="deliveryDate" class="form-label">Delivery Date</label>
                                        <div class="input-group">
                                            <input type="date" id="deliveryDate" formControlName="deliveryDate"
                                                class="form-control" title="Click to change date" />
                                            <!-- <button type="button" class="btn btn-success">Change Date</button> -->
                                        </div>
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="sentTo" class="form-label">Sent To</label>
                                        <select formControlName="sentTo" id="sentTo" class="form-control custom-select">
                                            <option value="" disabled selected>Select recipient</option>
                                            <option value="Sub Inventory Store" selected>Sub Inventory Store</option>
                                            <option *ngFor="let client of clientList" [value]="client._id">{{
                                                client.clientName }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="group" class="form-label">Group</label>
                                        <select formControlName="group" id="group" class="form-control custom-select" (change)="updateSubcategories($event.target.value)">
                                          <option value="" disabled selected>Select a group</option>
                                          <option *ngFor="let category of materialOptions" [value]="category">{{ category }}</option>
                                        </select>
                                      </div>
                                      <div class="col form-group mb-3">
                                        <label for="subgroup" class="form-label">Subgroup</label>
                                        <select formControlName="subgroup" id="subgroup" class="form-control custom-select">
                                          <option value="" disabled selected>Select a subgroup</option>
                                          <option *ngFor="let subgroup of subcategoryOptions" [value]="subgroup">{{ subgroup }}</option>
                                        </select>
                                      </div>
                                  </div>
                                  <div class="row">
                                    <div class="col form-group mb-3">
                                      <label for="material" class="form-label">Material</label>
                                      <select formControlName="material" id="material" class="form-control custom-select">
                                        <option value="" disabled selected>Select a material</option>
                                        <option *ngFor="let material of materialOptions" [value]="material">{{ material }}</option>
                                      </select>
                                    </div>
                                    <div class="col form-group mb-3">
                                      <label for="submaterial" class="form-label">Submaterial</label>
                                      <select formControlName="submaterial" id="submaterial" class="form-control custom-select">
                                        <option value="" disabled selected>Select a submaterial</option>
                                        <option *ngFor="let submaterial of submaterialOptions">{{ submaterial }}</option>
                                      </select>
                                    </div>
                                  </div>
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="description" class="form-label">Description/Size</label>
                                        <select formControlName="description" id="description"
                                            class="form-control custom-select">
                                            <option value="" disabled selected>Select a description</option>
                                            <option *ngFor="let description of descriptionOptions">{{ description }}
                                            </option>
                                        </select>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="deliveryNo" class="form-label">Delivery No</label>
                                        <input type="text" formControlName="deliveryNo" id="deliveryNo"
                                            class="form-control" />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="billNo" class="form-label">Bill No</label>
                                        <input type="text" formControlName="billNo" id="billNo" class="form-control" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col form-group mb-3">
                                        <label for="amount1" class="form-label">Amount1 (kgs)</label>
                                        <input type="text" formControlName="amount1" id="amount1"
                                            class="form-control" />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="amount2" class="form-label">Amount2 (bkts)</label>
                                        <input type="text" formControlName="amount2" id="amount2"
                                            class="form-control" />
                                    </div>
                                    <div class="col form-group mb-3">
                                        <label for="location" class="form-label">Location</label>
                                        <input type="text" formControlName="location" id="location"
                                            class="form-control" />
                                    </div>
                                </div>

                                <div class="text-end">
                                    <button type="submit" class="btn btn-outline-dark">{{ isUpdateMode ? 'Update':
                                        'Submit' }}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>